import { RouteConfig } from "vue-router";
import SummaryComponent from "@/views/summary/summary.vue";

export const SUMMARY_ROUTES: RouteConfig[] = [
  {
    path: "/summary",
    name: "SummaryComponent",
    component: SummaryComponent,
    meta: {
      requiresAuth: true
    }
  }
];